import React, { createContext, useContext, useState, useLayoutEffect, useCallback } from 'react';
import {
  BACKGROUND_PRESETS,
  readStoredBackgroundId,
  writeStoredBackgroundId,
  applyBackgroundPresetToDocument,
} from '../theme/appearance';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [backgroundId, setBackgroundIdState] = useState(() => readStoredBackgroundId());

  useLayoutEffect(() => {
    applyBackgroundPresetToDocument(backgroundId);
  }, [backgroundId]);

  const setBackgroundId = useCallback((id) => {
    setBackgroundIdState(id);
    writeStoredBackgroundId(id);
  }, []);

  return (
    <ThemeContext.Provider value={{ backgroundId, setBackgroundId, presets: BACKGROUND_PRESETS }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
